import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Transformer = /*#__PURE__*/function () {
  function Transformer() {
    _classCallCheck(this, Transformer);
  }
  return _createClass(Transformer, [{
    key: "buildInlineAdf",
    value: function buildInlineAdf(url) {
      return {
        type: 'inlineCard',
        attrs: {
          url: url
        }
      };
    }
  }, {
    key: "buildBlockAdf",
    value: function buildBlockAdf(url) {
      return {
        type: 'blockCard',
        attrs: {
          url: url
        }
      };
    }
  }, {
    key: "buildEmbedAdf",
    value: function buildEmbedAdf(url) {
      return {
        type: 'embedCard',
        attrs: {
          url: url,
          layout: 'wide'
        }
      };
    }
  }, {
    key: "toAdf",
    value: function toAdf(url, appearance) {
      switch (appearance) {
        case 'inline':
          return this.buildInlineAdf(url);
        case 'block':
          return this.buildBlockAdf(url);
        case 'embed':
          return this.buildEmbedAdf(url);
      }
    }
  }]);
}();